import { JourneyPhase, JourneyItem } from "../../components/journey-map";
import { DtoEntry, DtoTestSet } from "@/types";

const SCALE_INDEX_TO_COLOR: { [key: number]: string } = {
  0: "var(--fl-color-primary)",
  1: "rgb(85, 125, 225)",
  2: "var(--fl-color-secondary)",
};

export function buildJourneyPhases(
  solutionTestSet: DtoTestSet,
  entries: DtoEntry[]
): JourneyPhase[] {
  const solutionEntry = entries.find(
    ent => ent.testSetId === solutionTestSet._id
  );
  return solutionTestSet.scales.map((scale, i) => {
    return {
      id: scale._id,
      title: scale.scaleName,
      color: SCALE_INDEX_TO_COLOR[i],
      items: solutionTestSet.items
        .filter(item => item.category === scale.category)
        .map<JourneyItem>(item => {
          const key = item.dbColumn as `T${number}`;
          return {
            id: item._id,
            label: item.v1,
            completed: !!solutionEntry?.[key],
          };
        }),
    };
  });
}

export function calculateProgress(phases: JourneyPhase[]): number {
  const totalItems = phases.reduce((sum, phase) => sum + phase.items.length, 0);
  if (totalItems === 0) return 0;

  const completedItems = phases.reduce(
    (sum, phase) => sum + phase.items.filter(item => item.completed).length,
    0
  );

  return Math.round((completedItems / totalItems) * 100);
}
